//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
import { has } from "lodash";
//  -- Actions ------------------------
import { logToSentry } from "utils/networkErrorUtils";
// import { sortBy } from "lodash";
import * as SuperLessonActions from './actions';
import axios from 'axios';
import configInfo from "config"
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create Super Lesson --------------------

export const handleCreateDifferentiationLesson = (data) => async (dispatch) => {
    // await dispatch(SuperLessonActions.createVocabulary());
    try {
        const lessonData = await apis.post('differentiation_lesson', `/create`, {
            body: data
        });
        if (data.id) {
            await dispatch(SuperLessonActions.updateDifferentionLesson(lessonData));
        } else {
            await dispatch(SuperLessonActions.createDifferentionLesson(lessonData));
        }
        return lessonData
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating differentiation lesson',
                error,
                module: 'DIFFERENTIATION_LESSON',
                operation: 'CREATE_DIFFERENTIATION_LESSON'
            });
        }
    }
};



export const handleGetDifferentiationLesson = (data) => async (dispatch) => {
    try {
        const lessonData = await apis.post('differentiation_lesson', `/list`, {
            body: data
        });
        await dispatch(SuperLessonActions.listDifferentionLesson(lessonData));
        return lessonData;
    } catch (error) {
        if (error) {
            logToSentry({
                message: 'getting differentiation lesson',
                error,
                module: 'DIFFERENTIATION_LESSON',
                operation: 'GET_DIFFERENTIATION_LESSON'
            });
            return null;
        }
    }
};

//  -- Delete Book vocabulary ----------
export const handleDeleteDifferentiationLesson = (id) => async (dispatch) => {
    if (!id) return;
    // dispatch(SuperLessonActions.deleteVocabulary())
    try {
        const vocabulary = await apis.del('differentiation_lesson', `/delete/${id}`);
        if (has(vocabulary, "id")) {
            await dispatch(SuperLessonActions.deleteDifferentionLesson(vocabulary));
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting differentiation lesson',
                error,
                module: 'DIFFERENTIATION_LESSON',
                operation: 'DELETE_DIFFERENTIATION_LESSON'
            });
        }
    }
};

export const handleUpdateDifferntiationlession = (id, content) => async (dispatch) => {
    if (!id) return;
    try {
        const superlession = await apis.post('differentiation_lesson', `/updateContent`,{
            body:{
                id,content
            }
        });
        if (superlession && superlession.success) {
            await dispatch(SuperLessonActions.updateDifferentionLesson(superlession.data));
        }
        return superlession;
    } catch (error) {
        if (error && error.message !== "Network Error") {
            logToSentry({
                message: 'updating differentiation lesson',
                error,
                module: 'DIFFERENTIATION_LESSON',
                operation: 'UPDATE_DIFFERENTIATION_LESSON'
            });
        }
    }
    return null;
};